import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Button } from 'react-bootstrap'

const ReaderToolbarButton = props => {
  if (props.displayButton) {
    return (
      <div id={props.outerDivID}>
        <OverlayTrigger placement="top" overlay={props.buttonOverlay}>
          <div>
            <Button
              bsStyle={props.buttonStyle}
              bsSize="sm"
              aria-haspopup={!props.buttonHref && 'dialog'}
              onClick={props.onClickFunc ? props.onClickFunc : null}
              href={props.buttonHref ? props.buttonHref : '#'}
              style={{ paddingLeft: '0px' }}
            >
              {props.children}
            </Button>
          </div>
        </OverlayTrigger>
        <div className="clearfix" />
      </div>
    )
  } else {
    return <div />
  }
}

ReaderToolbarButton.propTypes = {
  outerDivID: PropTypes.string.isRequired,
  buttonOverlay: PropTypes.object.isRequired,
  buttonStyle: PropTypes.string.isRequired,
  onClickFunc: PropTypes.func,
  buttonHref: PropTypes.string,
  displayButton: PropTypes.bool.isRequired,
}

export default ReaderToolbarButton
